var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _ellipse, _path13, _path14, _g2, _rect, _rect2, _g3, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEndCapture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 240.112,
    height: 395.51,
    viewBox: "0 0 240.112 395.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3384",
    "data-name": "Rect\\xE1ngulo 3384",
    width: 150.482,
    height: 117.945,
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3382",
    "data-name": "Rect\\xE1ngulo 3382",
    width: 150.441,
    height: 138.939
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3387",
    "data-name": "Grupo 3387",
    transform: "translate(-11014 153.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3381",
    "data-name": "Grupo 3381",
    transform: "translate(11014 -153.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Captura_de_fachada",
    "data-name": "Captura de fachada",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2796",
    "data-name": "Grupo 2796",
    transform: "translate(0 0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8635",
    "data-name": "Trazado 8635",
    d: "M315.16,455.069s-22.254-28.265-19.416-32.81,16.531-8.424,16.531-8.424l7.022,7.656Z",
    transform: "translate(-286.743 -168.872)",
    fill: "#fbcfa7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8636",
    "data-name": "Trazado 8636",
    d: "M319.7,286.522c-7.122-12.326-12.239-15.805-20.667-12.6-4.527,1.721-11.842,8.876-9.534,17.764,1.918,7.383,7.4,17.167,17.2,20.806a12.8,12.8,0,0,0,6.437.677C326.691,311.147,328.227,301.282,319.7,286.522Z",
    transform: "translate(-285.889 -150.172)",
    fill: "#fbcfa7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8637",
    "data-name": "Trazado 8637",
    d: "M322.66,393.776s-33.093-19.7-31.206-25.311,15.6-13.268,15.6-13.268l9.5,6.429Z",
    transform: "translate(-286.197 -161.097)",
    fill: "#dead86"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5709",
    "data-name": "Trazado 5709",
    d: "M316.078,292.833a43.234,43.234,0,0,0,2.974,6.8c.455.912.939,1.794,1.395,2.709.645,1.234,1.261,2.494,1.795,3.809V292.908A39.307,39.307,0,0,1,316.078,292.833Zm130.3-161.406h-111.4c-13.087,0-23.678,11.209-23.678,25.072V417.9c0,.4,0,.832.026,1.207v.267c0,.187.026.375.026.563a2.35,2.35,0,0,0,.055.455v.108a9.282,9.282,0,0,0,.163,1.207,7.981,7.981,0,0,0,.134.858c.054.295.108.563.163.832a.237.237,0,0,0,.026.134c.054.268.108.537.187.8.08.326.187.671.268.991s.187.617.295.939c.026.108.08.215.108.326.108.295.215.562.326.832a26.237,26.237,0,0,0,1.744,3.588c.35.616.75,1.233,1.154,1.823a24.946,24.946,0,0,0,2.9,3.405c.268.267.537.509.8.75s.563.489.832.7a13.226,13.226,0,0,0,1.421,1.073c.215.163.428.3.644.429.241.163.508.326.778.489s.536.326.8.455c.295.163.616.326.912.456a.2.2,0,0,0,.134.054c.295.163.591.267.886.4.241.108.489.215.724.3a5.347,5.347,0,0,0,.7.241,4.857,4.857,0,0,0,.67.215c.4.135.8.242,1.207.35.326.08.644.163.991.215a21.223,21.223,0,0,0,2.227.349,21.588,21.588,0,0,0,2.306.108H446.3c12.469,0,22.686-10.19,23.626-23.089,0-.215.026-.4.026-.617h0c0-.428.026-.858.026-1.287V156.5C470.056,142.636,459.463,131.427,446.376,131.427Zm12.818,271.407H322.217V171.545H459.194V402.834Zm-143.116-110a43.234,43.234,0,0,0,2.974,6.8c.455.912.939,1.794,1.395,2.709.645,1.234,1.261,2.494,1.795,3.809V292.908A39.307,39.307,0,0,1,316.078,292.833Z",
    transform: "translate(-288.838 -131.427)",
    fill: "#e2e0e1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_2394",
    "data-name": "Rect\\xE1ngulo 2394",
    d: "M0,0H150.788V231.29H0Z",
    transform: "translate(26.943 39.26)",
    fill: "#fafafa"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5712",
    "data-name": "Trazado 5712",
    d: "M463.4,153a6.087,6.087,0,1,1-6.087-6.087A6.087,6.087,0,0,1,463.4,153Z",
    transform: "translate(-307.392 -133.481)",
    fill: "#5b5b5a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5732",
    "data-name": "Trazado 5732",
    d: "M427.4,153.493a2.883,2.883,0,0,1-2.87,2.9H373.565a2.9,2.9,0,0,1-2.9-2.9h0a2.885,2.885,0,0,1,2.871-2.9h50.97a2.885,2.885,0,0,1,2.9,2.871v.026Z",
    transform: "translate(-296.71 -133.969)",
    fill: "#5b5b5a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2795",
    "data-name": "Grupo 2795",
    transform: "translate(52.254 149.847)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5710",
    "data-name": "Trazado 5710",
    d: "M533.5,507.562s-2.481,17.163-23.828,29.924c-23.385,13.978-45.927,12.293-45.927,12.293s-10.04-10.529-14.347-16.726c-11.083-14.777-26.921-11.166-64.206-36.3-9.887-8.68-33.171-19.637-39.55-31.028l102.247-1.09c11.095,0,22.068-3.439,26.381-17.755l.227-62.659a50.85,50.85,0,0,1,7.563,6.928c-.683-3.006-.342-6.743-.524-9.955-.159-3.212-.866-6.06-1.23-9.3-.547-3.9.706-7.473-1.277-11-1.411-2.825-3.464-5.878-4.419-9.09v.591c-5.468-10.912-4.31-39.106.7-45.44a17.539,17.539,0,0,1,5.957-2.771c4.776-.086,5.011.444,7.167,1.569a48.829,48.829,0,0,1,5.433,13.107c1.981,8.27,4.153,9.568,7.05,14.055,5.626,15.512,10.677,16.528,13.182,27.237,1.843,8.7,2.365,19.23,5.957,27.369,3.246,14.578,9.357,17.184,8.451,37.356-2.766,13.4-10.769,50.01-9.975,53.863C520.664,489.044,528.4,493.494,533.5,507.562Z",
    transform: "translate(-345.646 -304.18)",
    fill: "#fbcfa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5733",
    "data-name": "Trazado 5733",
    d: "M488.776,457.954c-3.257,15.263-5.832,16.7-11.481,23.032-17.133,19.227-80.888,5.5-99.569,2.039-1.709-2.6-9.535-2.882-10.855-5.3l86.648-.707c10.162,0,20.19-5.868,23.57-19.5.046-.342.092-.661.114-1.025.046-.364.046-.707.068-1.071.039-.286.055-2.447.046-2.736V396.673A29.65,29.65,0,0,1,481.6,400.3C481.576,400.3,490.957,447.746,488.776,457.954Z",
    transform: "translate(-348.46 -316.443)",
    fill: "#ceac91"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1629",
    "data-name": "Grupo 1629",
    transform: "translate(172.874 152.257)",
    style: {
      isolation: "isolate"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5734",
    "data-name": "Trazado 5734",
    d: "M489.333,329.429c.228,11.436,1.845,20.172,3.717,23.338v4.8c-1.3-.868-8.349-9.235-8.344-26.045a45.3,45.3,0,0,1,4.628-20.319c.806-1.016,2.245-3.673,3.717-4.248v2.384C491.522,310.666,489.333,324.507,489.333,329.429Z",
    transform: "translate(-484.705 -306.958)",
    fill: "#c1c1c1"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8638",
    "data-name": "Trazado 8638",
    d: "M311.652,339.571s7.036,2.081,7.016,18.827c-.02,16.532-7.388,18.486-7.388,18.486Z",
    transform: "translate(-288.836 -159.025)",
    fill: "#c1c1c1",
    style: {
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8639",
    "data-name": "Trazado 8639",
    d: "M312.269,353.96c-1.769-12.554-4.555-17.209-12.576-17.505-4.309-.159-12.787,3.173-13.975,11.262-.987,6.722.113,16.646,6.887,23.032a11.4,11.4,0,0,0,5.042,2.789C309.464,376.583,314.173,367.475,312.269,353.96Z",
    transform: "translate(-285.405 -158.611)",
    fill: "#fbcfa7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8640",
    "data-name": "Trazado 8640",
    d: "M311.265,396.147s4.858,1.236,4.8,13.272c-.058,13.005-5.09,13.273-5.09,13.273Z",
    transform: "translate(-288.796 -166.527)",
    fill: "#c1c1c1",
    style: {
      isolation: "isolate"
    }
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8641",
    "data-name": "Trazado 8641",
    d: "M311.139,405.672c-.145-6.781.331-9.685-5.859-11.033-3.326-.724-10.37.764-12.4,7.068-1.689,5.238-2.2,13.324,2.19,19.369.893,1.231,8.724,2.672,11.819.817C310.935,419.465,311.256,411.133,311.139,405.672Z",
    transform: "translate(-286.233 -166.305)",
    fill: "#fbcfa7"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8642",
    "data-name": "Trazado 8642",
    d: "M291.744,412.75s2.129-6.3,4.669-9.858,5.754-8.312,5.754-8.312-7.025,1.289-8.449,5.429S291.422,410.568,291.744,412.75Z",
    transform: "translate(-286.237 -166.319)",
    fill: "#fff5ed"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8643",
    "data-name": "Trazado 8643",
    d: "M309.447,424.56c-.881,1.336-7.52,2.479-8.724,2.064-5.684-1.964,9,5.03,9,5.03Z",
    transform: "translate(-287.262 -170.294)",
    fill: "#dead86"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8644",
    "data-name": "Trazado 8644",
    d: "M306.779,338.678c1.2.913-5.261-2.712-11.356-.482-4.092,1.5-9.187,8.453-9.268,8.069-.53-2.511,6.483-12.335,16.429-9.725A11.959,11.959,0,0,1,306.779,338.678Z",
    transform: "translate(-285.501 -158.565)",
    fill: "#fff5ed"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8645",
    "data-name": "Trazado 8645",
    d: "M310.445,275.229c.128-.679,3.154,8.788,2.725,19.208a133.168,133.168,0,0,1-2.241,19.178S304.809,304.949,310.445,275.229Z",
    transform: "translate(-288.409 -150.489)",
    fill: "#c1c1c1",
    style: {
      isolation: "isolate"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8646",
    "data-name": "Trazado 8646",
    d: "M508.405,304.871s2.089,9.516,5.427,19.346,8.674,8.8,8.674,8.8a40.7,40.7,0,0,1-4.481-8.782C515.4,316.51,512.986,306.495,508.405,304.871Z",
    transform: "translate(-314.973 -154.424)",
    fill: "#fee4d6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_165",
    "data-name": "Enmascarar grupo 165",
    transform: "translate(11041.114 -114.747)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fondos_gris",
    transform: "translate(0 -21.492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1_1_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3385",
    "data-name": "Grupo 3385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3384",
    "data-name": "Grupo 3384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3383",
    "data-name": "Grupo 3383",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_312",
    "data-name": "Elipse 312",
    cx: 87.417,
    cy: 91.543,
    rx: 87.417,
    ry: 91.543,
    transform: "translate(-9.019 47.396)",
    fill: "#f7f7f7",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_313",
    "data-name": "Elipse 313",
    cx: 63.244,
    cy: 66.202,
    rx: 63.244,
    ry: 66.202,
    transform: "translate(-69.707 84.642)",
    fill: "#bcbcbc",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_314",
    "data-name": "Elipse 314",
    cx: 60.907,
    cy: 67.589,
    rx: 60.907,
    ry: 67.589,
    transform: "translate(-32.717 -36.953)",
    fill: "#e3e3e3",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12010",
    "data-name": "Trazado 12010",
    d: "M-118.465-91.171c20.485-8.691,103.082-41.591,156.649-7.887,6.938,4.345,19.609,12.6,23.3,27.277,8.07,32.206-34.543,66.348-39.071,70C-12.1,25.859-51.058,26.078-73.916,26.224c-32.1.183-57.876.329-76.1-19.389-24.136-26.108-27.313-78.653-4.455-95.121C-143.514-96.174-128.871-94.2-118.465-91.171Z",
    transform: "translate(107.912 91.318)",
    fill: "#e0e0e0",
    opacity: 0.58
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12011",
    "data-name": "Trazado 12011",
    d: "M366.173-11.071c17.637-1.388,51.6,53.348,33.265,94.756-14.022,31.622-51.888,40.349-76.1,38.779-42.832-2.775-82.049-40.2-86.358-84.715-4.053-41.554,22.639-86.1,42.832-85.08,25.341,1.315,35.419,74.052,56.89,72.153C351.166,23.545,352.7-10.012,366.173-11.071Z",
    transform: "translate(-150.188 49.046)",
    fill: "#eaeaea",
    opacity: 0.22
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12012",
    "data-name": "Trazado 12012",
    d: "M-141.6,174.525s-.365-67.7,74.235-53.494,83.619-16.14,87.052-37.5,59.921-61.162,81.392-24.063,63.682,165.7-53.9,171.657-7.559-66.676-61.491-79.31S-71.491,258.473-141.6,174.525Z",
    transform: "translate(89.895 -9.113)",
    fill: "#d6d6d6",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3386",
    "data-name": "Grupo 3386",
    transform: "translate(48.346 54.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12013",
    "data-name": "Trazado 12013",
    d: "M133.01,198.357a4.024,4.024,0,0,0-.073-.657h4.382a2.35,2.35,0,0,1,1.1.183.712.712,0,0,1,.292.657v2.629a.712.712,0,0,1-.292.657,2.461,2.461,0,0,1-1.1.183H132.9a1.359,1.359,0,0,0,.073-.657v-2.994Zm1.022,3.25h3.25a.491.491,0,0,0,.329-.073.284.284,0,0,0,.073-.292v-2.885a.393.393,0,0,0-.073-.292.677.677,0,0,0-.365-.073h-3.213Z",
    transform: "translate(-132.717 -161.514)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12014",
    "data-name": "Trazado 12014",
    d: "M155.682,197.7a1.768,1.768,0,0,1,1.022.219.687.687,0,0,1,.292.621v2.666a.78.78,0,0,1-.292.621,1.767,1.767,0,0,1-1.022.219H152.5a1.767,1.767,0,0,1-1.022-.219.687.687,0,0,1-.292-.621V198.54a.78.78,0,0,1,.292-.621,1.768,1.768,0,0,1,1.022-.219Zm.292.694a.393.393,0,0,0-.073-.292.677.677,0,0,0-.365-.073h-2.921a.491.491,0,0,0-.329.073.284.284,0,0,0-.073.292v2.885a.393.393,0,0,0,.073.292.6.6,0,0,0,.365.073h2.921a.491.491,0,0,0,.329-.073.284.284,0,0,0,.073-.292Z",
    transform: "translate(-144.325 -161.514)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12015",
    "data-name": "Trazado 12015",
    d: "M174.383,197.7l.073.438a3.2,3.2,0,0,0-.584-.073h-2.885a.491.491,0,0,0-.329.073.284.284,0,0,0-.073.292v2.885a.393.393,0,0,0,.073.292.678.678,0,0,0,.365.073h2.191a8.84,8.84,0,0,0,1.388-.073l-.073.438h-3.542a2.35,2.35,0,0,1-1.1-.183.712.712,0,0,1-.292-.657v-2.629a.712.712,0,0,1,.292-.657,2.578,2.578,0,0,1,1.1-.183h3.4Z",
    transform: "translate(-156.016 -161.514)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12016",
    "data-name": "Trazado 12016",
    d: "M137.841,212.1l.073.438a2.91,2.91,0,0,0-.4-.037,7.042,7.042,0,0,0-.876-.036H133.9a.659.659,0,0,0-.365.073.284.284,0,0,0-.073.292v.73a.394.394,0,0,0,.073.292.678.678,0,0,0,.365.073h2.7a2.652,2.652,0,0,1,1.132.183.722.722,0,0,1,.329.694v.913a.722.722,0,0,1-.329.694,2.653,2.653,0,0,1-1.132.183h-4.09l-.073-.4.4.037h3.725a.658.658,0,0,0,.365-.073.284.284,0,0,0,.073-.292v-.876a.393.393,0,0,0-.073-.292.785.785,0,0,0-.365-.073h-2.7a2.653,2.653,0,0,1-1.132-.183.722.722,0,0,1-.329-.694v-.767a.722.722,0,0,1,.329-.694,2.654,2.654,0,0,1,1.132-.183h3.98Z",
    transform: "translate(-132.4 -170.656)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12017",
    "data-name": "Trazado 12017",
    d: "M154.889,212.1a1.907,1.907,0,0,1,1.059.219.617.617,0,0,1,.292.621v2.775a.78.78,0,0,1-.292.621,1.907,1.907,0,0,1-1.059.219h-3.25a1.826,1.826,0,0,1-1.059-.219.617.617,0,0,1-.292-.621V212.94a.78.78,0,0,1,.292-.621,1.907,1.907,0,0,1,1.059-.219Zm.329.73a.393.393,0,0,0-.073-.292.786.786,0,0,0-.365-.073h-2.994a.658.658,0,0,0-.365.073.284.284,0,0,0-.073.292v2.994a.472.472,0,0,0,.073.292.786.786,0,0,0,.365.073h3.031a.659.659,0,0,0,.365-.073.284.284,0,0,0,.073-.292Z",
    transform: "translate(-143.752 -170.656)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12018",
    "data-name": "Trazado 12018",
    d: "M169.3,216.555a2.293,2.293,0,0,0,.11-.694v-3.067a2.293,2.293,0,0,0-.11-.694h1.242a2.292,2.292,0,0,0-.11.694v3.4h3.725c.183,0,.329-.037.475-.037l-.073.4Z",
    transform: "translate(-155.826 -170.656)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12019",
    "data-name": "Trazado 12019",
    d: "M190.193,216.126a.786.786,0,0,0,.365-.073.284.284,0,0,0,.073-.292V212.4a3.262,3.262,0,0,0-.073-.4h.73a1.832,1.832,0,0,0-.073.438c0,.146-.037.292-.037.438v2.775a.93.93,0,0,1-.219.694,1.619,1.619,0,0,1-.913.183h-3.286a2.277,2.277,0,0,1-1.059-.183.74.74,0,0,1-.292-.694V212.73a2.293,2.293,0,0,0-.11-.694h1.241a2.294,2.294,0,0,0-.109.694v3.031a.472.472,0,0,0,.073.292.526.526,0,0,0,.329.073Z",
    transform: "translate(-165.984 -170.592)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12020",
    "data-name": "Trazado 12020",
    d: "M204.205,212.4h-.657c-.219,0-.4.037-.548.037l.11-.438h5.331l.11.438c-.146-.037-.329-.037-.548-.073a4.188,4.188,0,0,0-.694-.037h-1.022v3.4a2.294,2.294,0,0,0,.11.694h-1.242a2.294,2.294,0,0,0,.11-.694v-3.4h-1.059Z",
    transform: "translate(-177.22 -170.592)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12021",
    "data-name": "Trazado 12021",
    d: "M220.932,215.861a2.293,2.293,0,0,0,.11.694H219.8a2.294,2.294,0,0,0,.11-.694v-3.067a2.293,2.293,0,0,0-.11-.694h1.242a2.293,2.293,0,0,0-.11.694Z",
    transform: "translate(-187.886 -170.656)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12022",
    "data-name": "Trazado 12022",
    d: "M230.689,212.1a1.825,1.825,0,0,1,1.059.219.617.617,0,0,1,.292.621v2.775a.78.78,0,0,1-.292.621,1.907,1.907,0,0,1-1.059.219h-3.25a1.907,1.907,0,0,1-1.059-.219.617.617,0,0,1-.292-.621V212.94a.78.78,0,0,1,.292-.621,1.907,1.907,0,0,1,1.059-.219Zm.329.73a.393.393,0,0,0-.073-.292.786.786,0,0,0-.365-.073h-3.031a.659.659,0,0,0-.365.073.284.284,0,0,0-.073.292v2.994a.472.472,0,0,0,.073.292.786.786,0,0,0,.365.073h3.031a.659.659,0,0,0,.365-.073.284.284,0,0,0,.073-.292Z",
    transform: "translate(-191.874 -170.656)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12023",
    "data-name": "Trazado 12023",
    d: "M249.42,216.555l-4.09-3.944-.037,3.213v.365c.037.146.037.256.073.4H244.6a1.812,1.812,0,0,0,.109-.475c0-.219.037-.475.037-.767v-2.191a5.216,5.216,0,0,0-.11-1.059h1.351l4.163,4.017.037-3.25V212.5a3.256,3.256,0,0,0-.073-.4h.767a1.833,1.833,0,0,0-.073.438c0,.146-.036.292-.036.438v3.615Z",
    transform: "translate(-203.63 -170.656)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12024",
    "data-name": "Trazado 12024",
    d: "M269.541,212.1l.073.438a2.908,2.908,0,0,0-.4-.037,7.043,7.043,0,0,0-.876-.036H265.6a.786.786,0,0,0-.365.073.284.284,0,0,0-.073.292v.73a.472.472,0,0,0,.073.292.786.786,0,0,0,.365.073h2.7a2.653,2.653,0,0,1,1.132.183.722.722,0,0,1,.329.694v.913a.722.722,0,0,1-.329.694,2.654,2.654,0,0,1-1.132.183h-4.09l-.073-.4.4.037h3.724a.658.658,0,0,0,.365-.073.284.284,0,0,0,.073-.292v-.876a.393.393,0,0,0-.073-.292.785.785,0,0,0-.365-.073h-2.7a2.653,2.653,0,0,1-1.132-.183.722.722,0,0,1-.329-.694v-.767a.722.722,0,0,1,.329-.694,2.653,2.653,0,0,1,1.132-.183h3.98Z",
    transform: "translate(-216.01 -170.656)",
    fill: "#898b8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12025",
    "data-name": "Trazado 12025",
    d: "M221.168,208.684a.584.584,0,1,0-.584.584.537.537,0,0,0,.584-.584Z",
    transform: "translate(-188.013 -168.116)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12026",
    "data-name": "Trazado 12026",
    d: "M172.887,106.6l-5.587,5.587h5.587Z",
    transform: "translate(-154.556 -103.679)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3383",
    "data-name": "Rect\\xE1ngulo 3383",
    width: 5.295,
    height: 8.8,
    transform: "translate(31.695 11.466)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12027",
    "data-name": "Trazado 12027",
    d: "M150.9,131.646h22.895c2.775,0,4.71-.438,5.769-1.315s1.607-2.556,1.57-5.076v-.913H175.84v1.935a3.712,3.712,0,0,1-.438,2.154,2.222,2.222,0,0,1-1.789.548H156.706V107l5.7-5.7h11.21a2.416,2.416,0,0,1,1.826.511,3.617,3.617,0,0,1,.4,2.154v2.666h5.295V104.99c0-2.52-.511-4.2-1.57-5.076S176.57,98.6,173.795,98.6H150.9a21.2,21.2,0,0,1,.475,5.149V126.5A22.988,22.988,0,0,1,150.9,131.646Z",
    transform: "translate(-144.145 -98.6)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12028",
    "data-name": "Trazado 12028",
    d: "M213.8,120.7l.4,3.213c-.219-.073-.876-.183-1.9-.365a25.489,25.489,0,0,0-4.236-.292H194.993a2.136,2.136,0,0,0-1.68.511,3.584,3.584,0,0,0-.438,2.045v5.258a3.713,3.713,0,0,0,.4,2.081c.256.329.84.475,1.716.475h12.963c2.629,0,4.418.438,5.441,1.278.986.84,1.5,2.447,1.5,4.857v6.39c0,2.41-.511,4.017-1.5,4.857s-2.812,1.278-5.441,1.278H188.494l-.4-2.812c.219.037.876.073,1.9.146s2.446.11,4.236.11h13.51a2.136,2.136,0,0,0,1.68-.511,3.357,3.357,0,0,0,.4-2.045V141a3.713,3.713,0,0,0-.4-2.081,2.177,2.177,0,0,0-1.716-.511H194.738c-2.629,0-4.418-.4-5.441-1.242-.986-.84-1.5-2.447-1.5-4.856v-5.477c0-2.41.511-4.017,1.5-4.856s2.812-1.242,5.441-1.242H213.8Z",
    transform: "translate(-167.571 -112.63)",
    fill: "#898b8d"
  })))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3385",
    "data-name": "Rect\\xE1ngulo 3385",
    width: 135.855,
    height: 5.048,
    transform: "translate(11048.427 25.565)",
    fill: "#c7c7c7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3386",
    "data-name": "Rect\\xE1ngulo 3386",
    width: 135.855,
    height: 5.048,
    transform: "translate(11048.427 55.108)",
    fill: "#c7c7c7"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "btn_hover",
    transform: "translate(11047.893 83.185)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_Color_l_Container",
    "data-name": "\\u21B3 \\uD83C\\uDFA8 Color l Container",
    width: 136.925,
    height: 16.268,
    rx: 8.134,
    transform: "translate(0 0)",
    fill: "#c20e30"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12029",
    "data-name": "Trazado 12029",
    d: "M0,0H64.5V2.524H0Z",
    transform: "translate(11084.104 90.057)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndCapture);
export default __webpack_public_path__ + "static/media/endCapture.2fd1ab9ce915187f33fcba55e7d5965e.svg";
export { ForwardRef as ReactComponent };